import {Map, fromJS} from 'immutable'

import {
  SET_USER,
  SET_CURRENT_USER,
  SET_USERS
} from '../action_types'

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_USERS:
      return state.mergeDeep(fromJS(action.users))

    case SET_USER:
      if (action.user.uid) {
        return state.set(action.user.uid, fromJS(action.user))
      }

    case SET_CURRENT_USER:
      if (action.user && action.user.uid) {
        return state.set(action.user.uid, fromJS(action.user))
      }

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/users.js
 **/